module.exports = __webpack_public_path__ + "img/d1.02cdeb95.jpg";